export const ARTISTS = [
  { name: "M Huncho", image: "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/un2hyqrh_M%20Huncho.jpg" },
  { name: "Quincy Tell'Em", image: "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/fizninfr_Quincy%20Tell%27em.jpg" },
  { name: "Nik Sitz", image: "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/tk0dnf1r_Nik%20Sitz.jpeg" },
  { name: "Colin Hennerz", image: "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/4cpoefap_Colin%20Hennerz.jpeg" },
  { name: "Jayron", image: "https://customer-assets.emergentagent.com/job_11b5f9da-5695-4228-9b97-e837295ecfda/artifacts/3v3qhv33_Jayron.jpg" },
  { name: "Nik Kastel", image: "https://customer-assets.emergentagent.com/job_11b5f9da-5695-4228-9b97-e837295ecfda/artifacts/fxnyo4xs_nikkastel.jpg" },
  { name: "Lister", image: "https://customer-assets.emergentagent.com/job_11b5f9da-5695-4228-9b97-e837295ecfda/artifacts/a99ujzo0_Lister.webp" },
  { name: "Lil Sknow", image: "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/1jgdue6l_Lil%20Sknow.jpg" },
  { name: "Lockdown", image: "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/l3emf0z2_Lockdown.jpg" },
  { name: "Colcci", image: "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/askythqk_Colcci.jpeg" },
  { name: "A-Clark & Vinny", image: "https://customer-assets-jt897jd0.emergentagent.net/job_11b5f9da-5695-4228-9b97-e837295ecfda/artifacts/81926e932960ab55_Post-foto-Artisti-Instagram.jpg" },
  { name: "ShortRound", image: "https://customer-assets-jt897jd0.emergentagent.net/job_11b5f9da-5695-4228-9b97-e837295ecfda/artifacts/7cce34e55d5e8e31_avatars-BWK52w4ZmsyL1m86-hBxehg-t1080x1080.jpg" },
  { name: "Tazi", image: "https://customer-assets-jt897jd0.emergentagent.net/job_11b5f9da-5695-4228-9b97-e837295ecfda/artifacts/5db9e519341248fe_images.jpeg" },
  { name: "Slice N Dice", image: "https://customer-assets-jt897jd0.emergentagent.net/job_11b5f9da-5695-4228-9b97-e837295ecfda/artifacts/b53f1a2e3c26a3e3_images-2.jpeg" },
  { name: "Romza", image: "https://customer-assets-jt897jd0.emergentagent.net/job_11b5f9da-5695-4228-9b97-e837295ecfda/artifacts/cb7766263eb732ea_images-3.jpeg" },
];

export const FAVOURITES = [
  {
    id: "package_dmrg_studio",
    title: "DMRG Studio Experience",
    subtitle: "Recording Studio Package",
    price: 400,
    perks: ["2 Hours Recording Time", "One Mix Included", "One Master Included", "Engineer on the desk"],
    accent: "from-dream-violet to-purple-600",
    badge: "Most Popular",
    badgeAccent: "bg-dream-violet",
    image: "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/wdkege0p_DSC_0076.jpg",
    imageAlt: "Recording Studio Control Room",
    ctaLabel: "Book Studio Session",
  },
  {
    id: "package_dj_popular",
    title: "Dream Maker Sessions",
    subtitle: "DJ Room Popular Package",
    price: 60,
    perks: ["2 Hours DJ Room Hire", "Pioneer CDJ-3000 × 3 + DJM-A9", "Free Water & Soft Drinks", "Sennheiser HD 25s + Fast WiFi"],
    accent: "from-cyan-500 to-blue-600",
    badge: "Best Value",
    badgeAccent: "bg-cyan-500",
    image: "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/o4aghb0q_DSC_2699.jpg",
    imageAlt: "DJ Room",
    ctaLabel: "Book DJ Room",
  },
  {
    id: "package_photography",
    title: "Photography",
    subtitle: "Press Shots Package",
    price: 299.99,
    perks: ["30+ Edited Photos", "Professional Lighting", "Multiple Backdrops", "Artist / Brand Ready"],
    accent: "from-yellow-500 to-orange-500",
    badge: "Trending",
    badgeAccent: "bg-yellow-500",
    image: "https://customer-assets-jt897jd0.emergentagent.net/job_11b5f9da-5695-4228-9b97-e837295ecfda/artifacts/3kzb9kui_DSC_7649.webp",
    imageAlt: "Press Shots Portrait Photography",
    ctaLabel: "Book Photo Shoot",
  },
];

export const REVIEWS = [
  { name: "Daniel Posenjak", quote: "Highly recommend this place to anyone needing press shots.", initials: "DP", accent: "from-dream-violet to-purple-600" },
  { name: "Antonio Vitalone", quote: "Great space to shoot some photos, great quality and the boys are absolute lads.", initials: "AV", accent: "from-cyan-500 to-blue-600" },
  { name: "Youi Gifted", quote: "Incredible services and equipment!", initials: "YG", accent: "from-yellow-500 to-orange-500" },
];

export const COURSES = [
  {
    slug: "lister",
    mentor: "Lister",
    title: "Ableton / FL Studio Production",
    meta: "4 weeks · 8 hrs · 1-on-1",
    price: "$1,250",
    photo: "https://customer-assets.emergentagent.com/job_11b5f9da-5695-4228-9b97-e837295ecfda/artifacts/7pa3kirm_images%20%282%29.jpeg",
    photoPos: "object-center",
    accent: "text-dream-violet",
    border: "hover:border-dream-violet/60",
  },
  {
    slug: "alex-m",
    mentor: "Alex M",
    title: "Ableton Live · Hardstyle / Rawstyle",
    meta: "8 weeks · 16 hrs · 1-on-1",
    price: "$2,499",
    photo: "https://customer-assets-jt897jd0.emergentagent.net/job_11b5f9da-5695-4228-9b97-e837295ecfda/artifacts/e2e0b29492bb4d41_Screenshot%202026-10-09%20at%209.07.08%E2%80%AFAM.png",
    photoPos: "object-[center_15%]",
    accent: "text-rose-400",
    border: "hover:border-rose-500/60",
  },
  {
    slug: "joel-petrika",
    mentor: "Joel Petrika",
    title: "DJ Lessons on CDJ-3000s",
    meta: "1.5 hr sessions · all levels",
    price: "$150",
    photo: "https://customer-assets.emergentagent.com/job_11b5f9da-5695-4228-9b97-e837295ecfda/artifacts/qcqgnkt9_IMG_0272.jpg",
    photoPos: "object-center",
    accent: "text-cyan-400",
    border: "hover:border-cyan-500/60",
  },
];

export const FILMED_VIDEO = "https://customer-assets-jt897jd0.emergentagent.net/job_11b5f9da-5695-4228-9b97-e837295ecfda/artifacts/2725e3b885798f91_Video-99532.mp4";
export const HERO_VIDEO = "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/ruegys0j_home%20banner%20video.MP4";
